import { useContext } from "react";
import { useLoaderData } from "react-router-dom";

import { getSystemMsg } from '../utils/api';

import MenuContext from '../store/MenuContext';
import TestInfoClasses from '../components/Tests/TestInfo.module.css';

const SystemMsg = () => {
    const systemMsg=useLoaderData();
	console.log(systemMsg);
    return (
    		<div className={TestInfoClasses.testInfo}>
    	    	<div className={TestInfoClasses.testInfoContent}>
    	    		<h2 className={TestInfoClasses.testTitle} >Terms Of Service</h2>
    	    		<p className={TestInfoClasses.htmlText}>
			      		<span dangerouslySetInnerHTML={{__html:systemMsg}} />
			      	</p>
			     </div>
            </div>
        
    );
};

export default SystemMsg;

export async function loader() {
    const response = await getSystemMsg("General");
	const resData = await response;
		return resData;
}